// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./insa-css/insa-clients/Kestrel/css/custom.css
// module id = 1887
// module chunks = 2